/* Fő szál fagyásfigyelő - src/services/stallWatchdog.js
 *
 * JAVÍTÁS (77. tétel - 32021458074): a meccsen a CR iPad 2 mp-re elfehéredett,
 * a hálózati kérések 9 mp-ig álltak, és utána a pálya nem reagált - a
 * Bugsnagben ebből semmi nem látszott, mert egy memóriahiány vagy a böngésző
 * saját fagyása nem JS-hiba. Ez a figyelő másodpercenként ellenőrzi, hogy az
 * időzítő pontosan lefutott-e: ha a fő szál (látható oldal mellett) legalább
 * STALL_BREADCRUMB_MS-ig nem futott, breadcrumbot hagy, így a következő
 * Bugsnag-eseménynél (pl. egy "Report screen discconnected") látszik, mikor és
 * mennyi ideig állt az oldal. Nagyon hosszú fagyásnál önálló eseményt is küld,
 * oldalbetöltésenként legfeljebb MAX_NOTIFIES darabot, hogy a maxEvents keretet
 * ne élje fel.
 *
 * Háttérbe tett lapnál a böngészők szándékosan lassítják az időzítőket - ezt
 * nem tekintjük fagyásnak (document.hidden, illetve ha a két mérés között a
 * lap akár csak egy pillanatra is rejtett volt).
 */
import Bugsnag from "@bugsnag/js";

const INTERVAL_MS = 1000;
const STALL_BREADCRUMB_MS = 1000;
const STALL_NOTIFY_MS = 5000;
const MAX_NOTIFIES = 3;

let timer = null;

function heapMB() {
    // Csak Chromium alapú asztali böngészőkben létezik (iOS-en nincs).
    if (typeof performance !== 'undefined' && performance.memory && performance.memory.usedJSHeapSize) {
        return Math.round(performance.memory.usedJSHeapSize / 1048576);
    }
    return undefined;
}

function report(stallMs) {
    const meta = {
        stallMs: Math.round(stallMs),
        route: window.location.hash,
        online: typeof navigator !== 'undefined' ? navigator.onLine : undefined,
        heapMB: heapMB()
    };
    console.warn('[STALL] A fő szál ' + meta.stallMs + ' ms-ig nem futott', meta);

    const bugsnagReady = typeof Bugsnag.isStarted === 'function' && Bugsnag.isStarted();
    if (!bugsnagReady) return;

    Bugsnag.leaveBreadcrumb('Main thread stall', meta, 'state');
    return meta;
}

export default {
    start() {
        if (timer) return;

        let last = performance.now();
        let hiddenSinceLastTick = document.hidden;
        let notifies = 0;

        document.addEventListener('visibilitychange', () => {
            if (document.hidden) hiddenSinceLastTick = true;
        });

        timer = setInterval(() => {
            const now = performance.now();
            const stallMs = now - last - INTERVAL_MS;
            const skip = hiddenSinceLastTick || document.hidden;
            last = now;
            hiddenSinceLastTick = document.hidden;

            if (skip || stallMs < STALL_BREADCRUMB_MS) return;

            const meta = report(stallMs);
            if (meta && stallMs >= STALL_NOTIFY_MS && notifies < MAX_NOTIFIES) {
                notifies++;
                Bugsnag.notify('Main thread stall', function (event) {
                    event.severity = 'info';
                    event.context = 'Main thread stall ' + meta.stallMs + ' ms';
                    event.addMetadata('stall', meta);
                });
            }
        }, INTERVAL_MS);
    },

    stop() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
};
